import { render, staticRenderFns } from "./TemplatesTab.vue?vue&type=template&id=7fb0dff2&"
import script from "./TemplatesTab.vue?vue&type=script&lang=js&"
export * from "./TemplatesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports